import { Injectable } from "@angular/core";
import { AppSettings } from "../../proyect.conf";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AutenticacionService } from "./autenticacion.service";
import { CanalRestriccionGestionEstado } from '../_models/canal-restriccion-gestion-estado';

@Injectable({
  providedIn: "root",
})
export class CanalRestriccionGestionEstadoService {
  private rutServicio =
    AppSettings.rutServiciosAPL + "/api/canalesRestriccionesGestionesEstados";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listado() {
    return this.httpClient
      .get(this.rutServicio)
      .pipe(map((res) => res as CanalRestriccionGestionEstado[]));
  }

  listadoHabilitados() {
    return this.httpClient
      .get(this.rutServicio + "/enabled")
      .pipe(map((res) => res as CanalRestriccionGestionEstado[]));
  }

  obtenerPorId(id: string) {
    return this.httpClient
      .get(this.rutServicio + "/" + id)
      .pipe(map((res) => res as CanalRestriccionGestionEstado));
  }

  obtenerPorCanal(idCanal: string) {
    return this.httpClient
      .get(this.rutServicio + "/canal/" + idCanal)
      .pipe(map((res) => res as CanalRestriccionGestionEstado[]));
  }

  obtenerPorCanalHabilitados(idCanal: string) {
    return this.httpClient
      .get(this.rutServicio + "/canal/" + idCanal + "/enabled")
      .pipe(map((res) => res as CanalRestriccionGestionEstado[]));
  }

  crear(regCrear: CanalRestriccionGestionEstado) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as CanalRestriccionGestionEstado));
  }

  actualizar(regActualizar: CanalRestriccionGestionEstado) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as CanalRestriccionGestionEstado));
  }

  bulk(registros: CanalRestriccionGestionEstado[]) {
    registros.forEach((e) => {
      e.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httpClient
      .post(this.rutServicio + '/bulk', registros)
      .pipe(map((res) => res as CanalRestriccionGestionEstado[]));
  }
}
